import * as React from 'react'
import { Plural, Singular } from 'react-content-engine'
import Content from '../../../pages/shared/content'
import { DaysAndDestination } from './destination'

export interface DayOption {
  days: number
  nights: number
  worldwide?: boolean
}

export interface DayToLocation {
  days: number
  locations: number[]
}

export interface LocationOptions {
  locations: number
  days: DayOption[]
}

export const driveOptions: DayOption[] = [
  { days: 2, nights: 1 },
  { days: 3, nights: 2 },
  { days: 4, nights: 3 },
]

export const trainOptions: DayOption[] = [
  { days: 2, nights: 1 },
  { days: 3, nights: 2 },
  { days: 4, nights: 3 },
]

export const oldDriveOptions: DayToLocation[] = [
  { days: 3, locations: [2] },
  { days: 4, locations: [2, 3] },
  { days: 7, locations: [3, 4] },
]

export const multiDriveOptions: LocationOptions[] = [
  {
    locations: 2,
    days: [
      { days: 3, nights: 2 },
      { days: 4, nights: 3 },
      { days: 5, nights: 4 },
    ],
  },
  {
    locations: 3,
    days: [
      { days: 5, nights: 4 },
      { days: 6, nights: 5 },
      { days: 7, nights: 6 },
      { days: 8, nights: 7 },
    ],
  },
  {
    locations: 4,
    days: [
      { days: 6, nights: 5 },
      { days: 7, nights: 6 },
      { days: 8, nights: 7 },
      { days: 9, nights: 8 },
      { days: 10, nights: 9 },
      { days: 11, nights: 10 },
    ],
  },
  {
    locations: 5,
    days: [
      { days: 8, nights: 7 },
      { days: 9, nights: 8 },
      { days: 10, nights: 9 },
      { days: 11, nights: 10 },
      { days: 12, nights: 11 },
      { days: 13, nights: 12 },
    ],
  },
  {
    locations: 6,
    days: [
      { days: 10, nights: 10 },
      { days: 11, nights: 10 },
      { days: 12, nights: 11 },
      { days: 13, nights: 12 },
      { days: 14, nights: 13 },
    ],
  },
  {
    locations: 7,
    days: [
      { days: 12, nights: 11 },
      { days: 13, nights: 12 },
      { days: 14, nights: 13 },
    ],
  },
]

export const flyOptions: DayOption[] = [
  { days: 3, nights: 2 },
  { days: 4, nights: 3 },
  { days: 5, nights: 4 },
  { days: 7, nights: 6, worldwide: true },
]

export const inControlOptions: DayOption[] = [
  { days: 3, nights: 2 },
  { days: 4, nights: 3 },
  { days: 5, nights: 4 },
]

export const foodLoversFlyOptions: DayOption[] = [
  { days: 3, nights: 2 },
  { days: 4, nights: 3 },
  { days: 5, nights: 4 },
]

export const foodLoversDriveOptions: DayOption[] = [
  { days: 2, nights: 1 },
  { days: 3, nights: 2 },
  { days: 4, nights: 3 },
]

export const insideEuropeOptions: DayOption[] = [
  { days: 3, nights: 2 },
  { days: 4, nights: 3 },
  { days: 5, nights: 4 },
  { days: 6, nights: 5 },
  { days: 7, nights: 6 },
]

export const outsideEuropeOptions: DayOption[] = [
  { days: 7, nights: 6 },
  { days: 8, nights: 7 },
  { days: 9, nights: 8 },
  { days: 10, nights: 9 },
  { days: 11, nights: 10 },
  { days: 12, nights: 11 },
]

export const multiFlyOptions: LocationOptions[] = [
  {
    locations: 2,
    days: [
      { days: 5, nights: 4 },
      { days: 6, nights: 5 },
      { days: 7, nights: 6 },
      { days: 8, nights: 7 },
      { days: 9, nights: 8 },
      { days: 10, nights: 9 },
    ],
  },
  {
    locations: 3,
    days: [
      { days: 8, nights: 7 },
      { days: 9, nights: 8 },
      { days: 10, nights: 9 },
      { days: 11, nights: 10 },
      { days: 12, nights: 11 },
      { days: 13, nights: 12 },
      { days: 14, nights: 13 },
    ],
  },
  {
    locations: 4,
    days: [
      { days: 10, nights: 9 },
      { days: 11, nights: 10 },
      { days: 12, nights: 11 },
      { days: 13, nights: 12 },
      { days: 14, nights: 13 },
    ],
  },
]

export function cantPickNumLocation(
  options: DayToLocation[],
  locations: number,
  days: number,
) {
  const option = options.find(x => x.days === days)
  return option ? option.locations.indexOf(locations) < 0 : false
}

export function getNumDays(options: LocationOptions[], locations: number) {
  const option = options.find(x => x.locations === locations)
  return option ? option.days : []
}

export function getDayOption(
  options: LocationOptions[],
  locations: number,
  days: number,
) {
  const option = options.find(x => x.locations === locations)
  return option ? option.days.find(x => x.days === days) : null
}

export function cantPickNumDays(
  options: LocationOptions[],
  days: number,
  locations: number,
) {
  const option = options.find(x => x.locations === locations)
  return option ? option.days.map(x => x.days).indexOf(days) < 0 : true
}

export interface DaysAndLoction {
  days: number
  locations: number
}

export function getDays(days: number) {
  return (
    <Content
      addNode
      contentKey="vars-days"
      vars={{ days: days.toString() }}
    >{`${days} Days`}</Content>
  )
}

export function getDaysAndNights(days: number, nights: number) {
  return (
    <Content
      addNode
      contentKey="vars-days-nights"
      vars={{
        days: days.toString(),
        nights: nights.toString(),
      }}
      plural={days > 1}
    >
      <Singular>{`${days} Days (${nights} night)`}</Singular>
      <Plural>{`${days} Days (${nights} nights)`}</Plural>
    </Content>
  )
}

export function getNights(nights: number) {
  return (
    <Content
      addNode
      contentKey="vars-nights"
      vars={{ nights: nights.toString() }}
      plural={nights > 1}
    >
      <Singular>{`${nights} night`}</Singular>
      <Plural>{`${nights} nights`}</Plural>
    </Content>
  )
}

export function getCitiesAndDays(days: number, locations: number) {
  return (
    <Content
      addNode
      contentKey="cities-locations-days"
      vars={{ days: days.toString(), locations: locations.toString() }}
      plural={locations > 1}
    >
      <Singular>{`${locations} City, ${days} days`}</Singular>
      <Plural>{`${locations} Cities, ${days} days`}</Plural>
    </Content>
  )
}

export function getCitiesDaysAndNights(
  days: number,
  nights: number,
  locations: number,
) {
  return (
    <Content
      addNode
      contentKey="cities-days-nights"
      vars={{
        days: days.toString(),
        nights: nights.toString(),
        locations: locations.toString(),
      }}
      plural={locations > 1}
    >
      <Singular>{`${locations} City, ${days} days (${nights} night)`}</Singular>
      <Plural>{`${locations} Cities, ${days} days (${nights} nights)`}</Plural>
    </Content>
  )
}

// Meta functions
export function getDaysFromValue(value: DaysAndDestination) {
  return getDays(value.days)
}

interface DaysDestDayOption {
  dest: number
  days: number
  options: DayOption[]
}

export function getDaysAndNightsFromValue(
  value: DaysDestDayOption,
): JSX.Element | string {
  const option = value.options.find(x => x.days === value.days)
  return option ? getDaysAndNights(option.days, option.nights) : ``
}

export function getNightsFromValue(value: DaysDestDayOption) {
  const option = value.options.find(x => x.days === value.days)
  return option && getNights(option.nights)
}

// Locations
export function getCitiesFromDaysAndLocation(value: DaysAndLoction) {
  return getCitiesAndDays(value.days, value.locations)
}

interface DaysCityLocationOption {
  days: number
  locations: number
  options: LocationOptions[]
}

export function getDaysFromLocation(value: DaysCityLocationOption) {
  const dayOption = value.options.find(x => x.locations === value.locations)
  const option = dayOption
    ? dayOption.days.find(x => x.days === value.days)
    : null
  return dayOption && option
    ? getCitiesAndDays(option.days, dayOption.locations)
    : getCitiesAndDays(value.days, value.locations)
}

export function getDaysAndNightsFromLocation(value: DaysCityLocationOption) {
  const dayOption = value.options.find(x => x.locations === value.locations)
  const option = dayOption
    ? dayOption.days.find(x => x.days === value.days)
    : null
  return dayOption && option
    ? getCitiesDaysAndNights(option.days, option.nights, dayOption.locations)
    : null
}

export function getNightsFromLocation(value: DaysCityLocationOption) {
  const dayOption = value.options.find(x => x.locations === value.locations)
  const option = dayOption
    ? dayOption.days.find(x => x.days === value.days)
    : null
  return dayOption && option ? getNights(option.nights) : undefined
}
